import { Button } from '@cokitchen/cokitchen-components';
import { RmxCheckIcon } from 'cokitchen-icons';
import LocalModal from 'components/base/local-modal';
import useEventDetailsContext from 'contexts/event-details.context';
import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};
const EventCreatedSuccessModal = ({ isOpen, onClose }: Props) => {
  const { formData } = useEventDetailsContext();
  return (
    <LocalModal isOpen={isOpen} onRequestClose={onClose}>
      <div className='w-[60%] flex flex-col justify-center items-center mx-auto'>
        <div className='w-[74px] h-[74px] bg-[#F4F1F1] rounded-full flex justify-center items-center mb-2'>
          <RmxCheckIcon className='w-[34px] h-[34px]' />
        </div>
        <p className='text-[#2E3031] text-[18px] font-medium text-center'>
          {formData.name} has been successsfully created
        </p>
        <Link to='/events'>
          <Button
            variant='block'
            color='primary'
            className='mt-6 h-[41px] w-[158px]'
            onClick={onClose}>
            Back to Events
          </Button>
        </Link>
      </div>
    </LocalModal>
  );
};

export default EventCreatedSuccessModal;
